// extracted by mini-css-extract-plugin
export var workHolder = "work-module--workHolder--3c92b";